import {
    ICustoPrevistoVGVMensal,
    ICustoPrevistoVGVMensalPayload,
    ICustoPrevistoVGVMensalResponse,
} from "../../../Interfaces/AssistenciaTecnica/CustoPrevistoVGVMensal/CustoPrevistoVGVMensalInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function CadastroDeCustosPrevistoVGVMensalService(
    requestBody: ICustoPrevistoVGVMensal
) {
    return Service(
        Axios.post(
            `/assistenciatecnica/custos/cadastrocustovgvmes`,
            requestBody
        )
    );
}

export async function GetCustosPrevistoVGVMensalService(ID_CUSTO: number) {
    return Service(
        Axios.get<ICustoPrevistoVGVMensal>(
            `/assistenciatecnica/custos/getcustovgvmes?ID_CUSTO=${ID_CUSTO}`
        )
    );
}

export async function ListagemDeCustosPrevistoVGVMensalService(
    requestBody: ICustoPrevistoVGVMensalPayload
) {
    return Service(
        Axios.post<ICustoPrevistoVGVMensalResponse>(
            `/assistenciatecnica/custos/listagemdecustovgvmes`,
            requestBody
        )
    );
}

export async function AtualizacaoDeCustosPrevistoVGVMensalService(
    requestBody: Array<ICustoPrevistoVGVMensal>
) {
    return Service(
        Axios.patch(
            `assistenciatecnica/custos/atualizacaodecustovgvmes`,
            requestBody
        )
    );
}

export async function DeleteDeCustosPrevistoVGVMensalService(ID: number) {
    return Service(
        Axios.delete(`/assistenciatecnica/custos/remocaodecustovgvmes?ID=${ID}`)
    );
}
